export enum UserType {
  UNKNOWN_USER_TYPE = 0,
  ALL = 2,
  PERSON = 3,
  COMPANY = 4,
}
